<script>
// import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import axios from "@/axios";

export default {
  page: {
    title: "Monitoreo GPS",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    // Layout,
  },
  data() {
    return {
      token: ''
    };
  },
  methods: {
    getToken() {
      let token
      axios.get(`/GetToken?rut=${this.$store.state.rutEmpresa.cuentaSeleccionada.value}`)
          .then((response) => {
            token = response.data
            console.log(token)
            window.open(`https://web.autorentas.cl/ConsultaGPS/Default?` +
                `rut=${token}`,
                "blank");
            // window.open(`https://web.autorentas.cl/ConsultaGPS/Default?` +
            //     `rut=${this.$store.state.rutEmpresa.cuentaSeleccionada.value}`,
            //     "blank");
            history.back();
          })
    }
  },
  mounted() {
    this.getToken()
  }
};
</script>
<template>
  <div></div>
<!--  <Layout>-->
<!--    <div classs="row">-->
<!--      <div class="col-12">-->
<!--        <div class="card">-->
<!--          <div class="card-body">-->
<!--            <b-row align-h="between" align-v="center" class="title">-->
<!--              <h4 class="card-tittle custom-title">MONITOREO GPS</h4>-->
<!--            </b-row>-->
<!--            <b-row class="p-2 text-center">-->
<!--              Embebed-->
<!--            </b-row>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </Layout>-->
</template>

<!--<style scoped>-->
<!--.custom-title{-->
<!--    margin:0 !important;-->
<!--    font-weight: bold;-->
<!--}-->
<!--.title{-->
<!--    padding: 15px;-->
<!--}-->
<!--.dp-full-width{-->
<!--    width: 100%;-->
<!--}-->
<!--</style>-->
